var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { findDriveDocumentActionFilterOption, getDriveDocumentActionFilterOptions } from '@web/components/ItemDetails/DriveItemDetails/utils';
import Select from '@web/components/ui/Form/Select';
import { trpc } from '@web/lib/trpc';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export var DriveDocumentEventsLogFilters = function (_a) {
    var _b, _c;
    var documentId = _a.documentId;
    var t = useTranslation().t;
    var filters = useFilters();
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var documentUsers = trpc.getDocumentUsers.useQuery({
        documentId: documentId
    }).data;
    var actionOptions = getDriveDocumentActionFilterOptions(t);
    var userOptions = __spreadArray([
        {
            id: null,
            name: t('filters.all')
        }
    ], ((_b = documentUsers === null || documentUsers === void 0 ? void 0 : documentUsers.users) !== null && _b !== void 0 ? _b : []).map(function (user) { return ({
        id: user.id,
        name: user.name || user.email,
        avatar: user.avatar
    }); }), true);
    var selectedUser = (_c = userOptions.find(function (user) { return user.id === filters.documentEventsUser; })) !== null && _c !== void 0 ? _c : userOptions[0];
    var selectedAction = findDriveDocumentActionFilterOption(actionOptions, filters.documentEventsAction, filters.documentEventsSubAction);
    var onUserChange = function (option) {
        var _a;
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                documentEventsUser: (_a = option.id) !== null && _a !== void 0 ? _a : null
            }
        });
    };
    var onActionChange = function (option) {
        var _a, _b;
        var actionOption = actionOptions.find(function (item) { return item.id === option.id; });
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                documentEventsAction: (_a = actionOption === null || actionOption === void 0 ? void 0 : actionOption.action) !== null && _a !== void 0 ? _a : null,
                documentEventsSubAction: (_b = actionOption === null || actionOption === void 0 ? void 0 : actionOption.subAction) !== null && _b !== void 0 ? _b : null
            }
        });
    };
    return (_jsxs("div", __assign({ className: "flex flex-wrap items-end gap-3" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-1 min-w-[160px]" }, { children: [_jsx("span", __assign({ className: "text-xs font-medium text-gray-500" }, { children: t('driveItemDetails.documentEventsLog.filters.employee') })), _jsx(Select, { options: userOptions, selected: selectedUser, onChange: onUserChange, placeholder: t('filters.selectUser') })] })), _jsxs("div", __assign({ className: "flex flex-col gap-1 min-w-[180px]" }, { children: [_jsx("span", __assign({ className: "text-xs font-medium text-gray-500" }, { children: t('driveItemDetails.documentEventsLog.filters.action') })), _jsx(Select, { options: actionOptions.map(function (option) { return ({
                            id: option.id,
                            name: option.name
                        }); }), selected: selectedAction
                            ? { id: selectedAction.id, name: selectedAction.name }
                            : actionOptions[0], onChange: onActionChange, placeholder: t('app.driveAdvancedSearch.filters.actionTypes.any') })] }))] })));
};
